export default "__VITE_ASSET__CPvdMADI__"